import axios from "axios";
import { apiURL } from "../config/config";
import { clearQuotationCache } from "../utils/quotationCache";
import { clearTimesheetCache } from "../utils/timesheetCache";

const SESSION_INTERCEPTOR_KEY = "__apiSessionInterceptorInstalled";
let sessionRedirectInProgress = false;

const isApplicationApiRequest = (url = "") => {
  const requestUrl = String(url);
  return requestUrl.startsWith(apiURL) || requestUrl.startsWith("/api/");
};

export const isExpiredSessionResponse = (error) => {
  if (typeof window === "undefined" || !localStorage.getItem("token")) {
    return false;
  }

  const status = error?.response?.status;
  if (status === 401) return true;
  if (status !== 403) return false;

  const responseData = error?.response?.data;
  const message = String(
    responseData?.message || responseData?.error || responseData || ""
  ).toLowerCase();

  return /(?:token|jwt|session).*(?:expired|invalid)|(?:expired|invalid).*(?:token|jwt|session)|not authorized|unauthenticated/.test(
    message
  );
};

export const redirectToLoginAfterSessionExpiry = () => {
  if (sessionRedirectInProgress || typeof window === "undefined") return;
  sessionRedirectInProgress = true;

  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("teams");
  localStorage.removeItem("departments");
  localStorage.removeItem("timesheetClients");
  clearQuotationCache();
  clearTimesheetCache();

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

export const installApiSessionInterceptor = () => {
  if (
    typeof window === "undefined" ||
    window[SESSION_INTERCEPTOR_KEY]
  ) {
    return;
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        isApplicationApiRequest(error?.config?.url) &&
        isExpiredSessionResponse(error)
      ) {
        redirectToLoginAfterSessionExpiry();
      }

      return Promise.reject(error);
    }
  );

  window[SESSION_INTERCEPTOR_KEY] = true;
};

